// reducers/alarms.js
import { ALARM_ACTIONS } from '../actions/alarms';

const initialState = {
  alarms: [],
  loading: false,
  error: null
};

const alarmsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALARM_ACTIONS.FETCH_ALARMS:
      return {
        ...state,
        alarms: action.payload,
        loading: false
      };
      
    case ALARM_ACTIONS.CREATE_ALARM:
      return {
        ...state,
        alarms: [...state.alarms, action.payload]
      };
      
    case ALARM_ACTIONS.TOGGLE_ALARM:
      return {
        ...state,
        alarms: state.alarms.map(alarm => 
          alarm.alarmId === action.payload.alarmId
            ? { ...alarm, isActive: action.payload.isActive }
            : alarm
        )
      };
      
    case ALARM_ACTIONS.DELETE_ALARM:
      return {
        ...state,
        alarms: state.alarms.filter(alarm => alarm.alarmId !== action.payload)
      };
      
    case ALARM_ACTIONS.ADD_ALARM_NOTIFICATION:
      return {
        ...state,
        alarms: state.alarms.map(alarm => 
          alarm.alarmId === action.payload.alarmId
            ? { 
                ...alarm, 
                notifications: [action.payload.notification, ...alarm.notifications],
                unreadCount: alarm.unreadCount + 1
              }
            : alarm
        )
      };
      
    case ALARM_ACTIONS.FETCH_ALARM_NOTIFICATIONS:
      return {
        ...state,
        alarms: state.alarms.map(alarm => 
          alarm.alarmId === action.payload.alarmId
            ? { 
                ...alarm, 
                notifications: action.payload.notifications 
              }
            : alarm
        )
      };
      
    case ALARM_ACTIONS.MARK_NOTIFICATIONS_READ:
      return {
        ...state,
        alarms: state.alarms.map(alarm => 
          alarm.alarmId === action.payload
            ? { 
                ...alarm, 
                unreadCount: 0 
              }
            : alarm
        )
      };
      
    default:
      return state;
  }
};

export default alarmsReducer;